// extracted by mini-css-extract-plugin
export default {"spinning":"Spin_spinning__VKRGt","searching":"Spin_searching__2XzsN"};